/**
 * Client-safe Zod schemas for Billit/Peppol delivery tracking, shared by the invoice and
 * credit note and self-billing endpoints. Do NOT import @prisma/client or server-only modules here.
 */
import { z } from 'zod';

// Mirrors the Prisma `PeppolDeliveryStatus` enum.
export const PeppolDeliveryStatusSchema = z.enum(['NotSent', 'Created', 'Sent', 'Delivered', 'Refused', 'Failed']);
export type PeppolDeliveryStatus = z.infer<typeof PeppolDeliveryStatusSchema>;

export const PeppolDeliverySchema = z.object({
  status: PeppolDeliveryStatusSchema,
  /** Latest feedback: recipient response, refusal reason or send error. */
  detail: z.string().nullable(),
  sentAt: z.string().nullable(),
  checkedAt: z.string().nullable(),
  billitOrderId: z.string().nullable(),
});
export type PeppolDelivery = z.infer<typeof PeppolDeliverySchema>;

export const SendPeppolResponseSchema = z.object({
  /** On `failed`, the error is in `peppol.detail`. */
  outcome: z.enum(['sent', 'alreadySent', 'failed']),
  peppol: PeppolDeliverySchema,
});
export type SendPeppolResponse = z.infer<typeof SendPeppolResponseSchema>;

/** Statuses where sending again would put a second copy on the Peppol network, so it is blocked. */
export const PEPPOL_ALREADY_SENT_STATUSES: readonly PeppolDeliveryStatus[] = ['Sent', 'Delivered', 'Refused'];
